module.exports = __webpack_public_path__ + "assets/img/sailing-version-function-bg.0f668e55.png";